<template>
  <div>
    <div class="uk-margin" v-if="!isLoading && !modeEdit">
<!--        <label>{{ local_page_keys.label_download_photo }}:</label>-->
<!--      <v-select-->
<!--          :options="retouchersList"-->
<!--          label="text"-->
<!--          :reduce="retoucher => retoucher.value"-->
<!--          v-model="selectedRetoucherObj"-->
<!--          @input="changeRetoucher"-->
<!--          :clearable="true"-->
<!--          class="tm-v-select">-->
<!--      </v-select>-->
      <!--не показывать для новых заказов, когда проверяющий может добавить функции-->
      <template v-if="prev_status_order !== 'hold-admin-new'">
      <!--выпадающий список ретачеров-->
        <div class="uk-margin uk-background-muted selectedRetoucher" style="padding: 15px;" v-show="education != 1">
  <!--        <select v-model="selectedRetoucher"-->
  <!--                class="uk-select"-->
  <!--                name="selectedRetoucher"-->
  <!--                ref="selectedRetoucher"-->
  <!--                id="selectedRetoucher"-->
  <!--                :disabled="retouchersList.length <2">-->
  <!--          <option v-for="retoucher of retouchersList"-->
  <!--                  :key="retoucher.id"-->
  <!--                  :selected="selectedRetoucher ? 'selected' : false"-->
  <!--                  :style="{background:retoucher.color}"-->
  <!--                  :value="retoucher.value">-->
  <!--            {{ retoucher.name + (retoucher.email ? ' &#45;&#45; ' + retoucher.email : '')}}-->
  <!--          </option>-->
  <!--        </select>-->
          <div  v-if="retouchersList.length > 0" class="uk-grid uk-grid-small uk-child-width-1-1" data-uk-grid>
            <div>
              <label class="uk-display-block" style="cursor: pointer">
                <input class="uk-radio" type="radio" name="radio2" checked v-model="selectedRetoucher" :value="retouchersList[0].value"> {{retouchersList[0].name}}
              </label>
            </div>
            <div>
              <label class="uk-display-block" style="cursor: pointer">
                <input class="uk-radio" type="radio" name="radio2" v-model="selectedRetoucher" :value="retouchersList[1].value"> {{retouchersList[1].name}}
              </label>
              <div class="uk-dropdown tm-dropdown tm-dropdown-left-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: left-center; delay-hide: 400; delay-show: 0; offset: 10">
                {{local_page_keys.select_another_retoucher_tooltip}}
              </div>
            </div>
          </div>
        </div>
        <!--чекборкс если выше в выбрано отдать другому ретушеру-->
        <div v-if="selectedRetoucher === local_page_keys.select_another_retoucher" class="uk-margin">
          <label>
            <input type="checkbox"
                   v-model="checkboxCheckboxWithoutReasonValue"
                   class="uk-checkbox">
            {{ local_page_keys.checkbox_without_reason }}
          </label>
          <div class="uk-dropdown tm-dropdown tm-dropdown-left-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: left-center; delay-hide: 400; delay-show: 200; offset: 10">
            {{ local_page_keys.checkbox_without_reason_info }}
          </div>
        </div>
      </template>
      <!--блок кнопок-->
      <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center uk-child-width-1-2 uk-margin-small-top" data-uk-grid>
        <div v-if="!order_is_broken">
          <div v-if="prev_status_order == 'hold-admin-new'">
            <button type="button"
                    class="uk-button uk-button-success uk-button-large_ uk-width-1-1 uk-padding-remove"
                    @click="giveItToWork">
              {{local_page_keys.button_give_it_to_work}}
            </button>
            <div class="uk-dropdown tm-dropdown tm-dropdown-left-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: left-center; delay-hide: 400; delay-show: 1000; offset: 10">
              {{ local_page_keys.button_give_it_to_work_info }}
            </div>
          </div>
          <div v-else>
            <button type="button"
                    class="uk-button uk-button-danger uk-button-large_ uk-width-1-1 uk-padding-remove"
                    @click="showDialog('modeEdit', true)">
<!--              переделка-->
              {{ local_page_keys.button_redesigning }}
            </button>
            <div class="uk-dropdown tm-dropdown tm-dropdown-left-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: left-center; delay-hide: 400; delay-show: 1000; offset: 10">
              {{ local_page_keys.button_redesigning_info }}
            </div>
          </div>
        </div>
        <div v-if="!order_is_broken && main_photo_after !== null && prev_status_order !== 're-done-customer'">
          <button type="button"
                  class="uk-button uk-button-success uk-button-large_ uk-width-1-1 uk-padding-remove"
                  @click="submitOrder('done-admin')">
            <md-icon class="uk-margin-small-right">done</md-icon>
            {{ local_page_keys.button_good }}
          </button>
          <div class="uk-dropdown tm-dropdown tm-dropdown-left-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: left-center; delay-hide: 400; delay-show: 1000; offset: 10">
            {{ local_page_keys.button_good_info }}
          </div>
        </div>
        <div v-if="!order_is_broken && main_photo_after !== null && showCompleteOrderButton">
          <button type="button"
                  class="uk-button uk-button-border uk-button-large_ uk-width-1-1 uk-padding-remove"
                  @click="submitOrder('done-admin', true)">
            {{ local_page_keys.button_final_order ? local_page_keys.button_final_order : "Complete" }}
          </button>
          <div class="uk-dropdown tm-dropdown tm-dropdown-left-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: left-center; delay-hide: 400; delay-show: 1000; offset: 10">
            {{ local_page_keys.button_final_order_info }}
          </div>
        </div>
        <div v-if="order_is_broken">
          <button type="button"
                  class="uk-button uk-button-danger uk-button-large_ uk-width-1-1 uk-padding-remove"
                  @click="submitOrder('broken')">
            {{ local_page_keys.button_order_broken }}
          </button>
          <div class="uk-dropdown tm-dropdown tm-dropdown-left-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: left-center; delay-hide: 400; delay-show: 1000; offset: 10">
            {{ local_page_keys.button_order_broken_info }}
          </div>
        </div>
        <div v-else>
          <template v-if="education != 1">
            <button type="button"
                    class="uk-button uk-button-secondary uk-button-large_ uk-width-1-1 uk-padding-remove"
                    @click="showDialog('showDialog10', false)">
              {{ local_page_keys.button_reject_order }}
            </button>
            <div class="uk-dropdown tm-dropdown tm-dropdown-left-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: left-center; delay-hide: 400; delay-show: 1000; offset: 10">
              {{ local_page_keys.button_reject_order_info }}
            </div>
          </template>
        </div>
        <div v-if="(prev_status_order === 'rejected-retoucher' || prev_status_order === 'hold-admin-new' ) && download_task_status === 'uploading'">
         <button type="button"
                  class="uk-button uk-button-primary uk-button-large_ uk-width-1-1 uk-padding-remove"
                  @click="submitOrder('wait-for-download-photo')">
            {{ local_page_keys.button_wait_for_download_photo }}
          </button>
          <div class="uk-dropdown tm-dropdown tm-dropdown-left-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: left-center; delay-hide: 400; delay-show: 1000; offset: 10">
            {{ local_page_keys.button_wait_for_download_photo_info }}
          </div>
        </div>
      </div>
    </div>

    <!--ДИАЛОГОВЫЕ ОКНА-->
    <!--Отклонить заказ-->
    <md-dialog
        class="tm-check-dialog"
        :md-active.sync="showDialog10"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true"
        :class="classDisplay"
        ref="">
      <div class="uk-padding_ uk-position-relative tm-modal-page">
        <a href="#" class="uk-position-top-right tm-dialog-close" @click="closeDialog"><span class="material-icons">close</span></a>

        <div class="uk-modal-header">
          <h2 class="uk-modal-title">
            {{local_page_keys.reject_reason_label_select_reason }}
          </h2>
        </div>

        <div class="uk-modal-body">
          <div class="uk-grid uk-child-width-1-3 tm-reject-order-reason-grid" data-uk-grid data-uk-height-match="target: > div > label">
            <div v-for="(reason, index) in rejectReasons" :key="index">
              <label :class="{'uk-background-muted': true, 'uk-display-block': true  }">
                <div class="uk-inline-clip uk-transition-toggle">
                  <img :src="reason.image" class="uk-transition-scale-up uk-transition-opaque" alt="">
                </div>
                <div class="uk-padding-small">
                  <input class="uk-radio" id="checkedSelectedReason" type="radio" v-model="selectedReasons" :value="reason" @change="updateSelection">
                  {{ reason.label }}
                </div>
              </label>
            </div>
            <div>
            </div>
            <div class="uk-width-1-1 uk-animation-slide-bottom-small" v-if="isLastReasonSelected">
              <div class="uk-margin-small">
                {{local_page_keys.reject_reason_label_detailed_reject }}
              </div>
              <textarea id="detailReason" class="uk-textarea tm-height-small "  v-model="rejectionDetails" ></textarea>
            </div>
          </div>
        </div>
        <div class="uk-modal-footer uk-text-right">
          <button type="button"
                  class="uk-button uk-button-secondary uk-button-large"
                  @click="submitOrder('rejected-admin')">
            {{ local_page_keys.button_reject_order }}
          </button>
        </div>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import convertBase64ToBlob from '../../../../filters/convertBase64ToBlob.js';

export default {
  name: "ActivitiesOfProRetoucher",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    auto_order_check: {
      type: Number,
      default: 1
    },
    education: {
      type: Number,
    },
    faces: {
      type: [Object, Array],
      require: true
    },
    local_page_keys: {
      type: Object,
      require: true
    },
    main_photo_after: {
      require: true
    },
    main_photo_before: {
      require: true
    },
    prev_status_order: {
      type: String,
      require: true
    },
    download_task_status: {
      type: String,
      require: true
    },
    canvasWidth: {
      type: Number,
      require: true
    },
    canvasHeight: {
      type: Number,
      require: true
    },
    order_id: {
      type: Number,
      require: true
    },
    cost: {
      type: Number,
      require: true
    },
    junior_order: {
      type: Boolean,
      require: true
    },
    order_number: {
      type: String,
      require: true
    },
    role: {
      type: String,
      require: true
    },
    showCompleteOrderButton: {
      type: Boolean,
      require: false
    },
    isValidateRate: {
      type: Boolean,
      require: false
    },
    modeEdit: {
      type: Boolean,
      default:false
    },
    permission: {
      type: String,
      default: 'read'
    },
  },
  filters: {
    convertBase64ToBlob
  },
  data: (props) => ({
    loadingInfo: false,
    classDisplay: '',
    showDialog10: false,
    isLoading: false,
    selectedRetoucher: false,
    selectedRetoucherObj: {},
    whichRetoucherObj: {},
    rejectedToAnotherRetoucher: false,
    beforeModalVisible: false,
    afterModalVisible: false,
    fixedPhoto: {
      image: null,
      fields: null,
    },
    selectedLevel: '',
    problemLevel: false,
    checked: [],
    retouchersList: [],
    retouchersRejectedToAnotherList: [],
    textarea1: null,
    checkboxCheckboxWithoutReasonValue: false,
    rejectReasons: [
      { label: props.local_page_keys.reject_reason_label_child_erotica, image: '/img/01_reject_order_reason_childish_erotica.jpg' },
      { label: props.local_page_keys.reject_reason_label_pornography, image: '/img/02_reject_order_reason_pornography.jpg' },
      { label: props.local_page_keys.reject_reason_label_identification_documents, image: '/img/03_reject_order_reason_documents.jpg' },
      { label: props.local_page_keys.reject_reason_label_clothes_removal, image: '/img/04_reject_order_reason_remove_clothes.jpg' },
      { label: props.local_page_keys.reject_reason_label_low_quality, image: '/img/05_reject_order_reason_low_quality.jpg' },
      { label: props.local_page_keys.reject_reason_label_options_are_not, image: '/img/06_reject_order_reason_other.jpg' }
    ],
    selectedReasons: [],
    rejectionDetails: '',
    hasValidationError:false
  }),
  components: {
  },
  methods: {
    /**
     *  send request order 'done-admin' or 'rejected-admin' to OrderController (method updateOrder)
     *  identifiable data: isLoading define as true - to display preloader
     *  takes as arguments: status - type: string - define status of current order in AirTable
     *  sending data: date - type: string of formated date-time
     *                status - type: string
     */
    async submitOrder(status, final = false) {

      if (!this.validateDeletedFunction()){
        return;
      }

      await this.$emit('checkValidateRating');

      if (!this.isValidateRate && status !== 'broken' && status !== 'rejected-admin')
       return

      let msg = '';
      if (status === 'done-admin') {
        msg = this.local_page_keys.alert_you_confirm_sending_of_a_message_order_accepted;
      } else if (status === 'done-admin-for-customer') {
        msg = this.local_page_keys.alert_return_the_order_to_the_customer_without_changes;
      } else if (status === 'broken') {
        msg = this.local_page_keys.alert_order_broken;
      } else if (status === 'wait-for-download-photo') {
        msg = this.local_page_keys.alert_wait_for_download_photo;
      }
      else {
        msg = this.local_page_keys.alert_you_want_to_reject_the_order;//the confirm's text is determined depending on the status text
      }

      if (confirm(msg)) {
        // if (status === 'done-admin') {
        //   logEvent(this.$analyticsInit, "order_completed", {orderId: this.order_id, cost: this.cost});
        // } else if (!this.order_is_broken && status !== 'done-admin') {
        //   logEvent(this.$analyticsInit, "order_cancel_admin", {orderId: this.order_id, cost: this.cost});
        // }

        if (!this.validateReasoneReject(status)) {
          return;
        }

        this.$emit('isLoading', true)
        let data;
        let value_auto_order_check  = new Number(this.auto_order_check).toString();
        try {

          switch (status) {
            case 'done-admin':
              this.role === 'test-retoucher' ? await this.$store.dispatch("postProRetoucher/doneAdmin", {
                role: 'pro-retoucher',
                final: final,
                auto_order_check: value_auto_order_check
              }) : await this.$store.dispatch("postProRetoucher/doneAdmin", {final: final,  auto_order_check: value_auto_order_check});
              data = await this.$store.getters['postProRetoucher/doneAdmin'];
              break;
            case 'broken':
              this.role === 'test-retoucher' ? await this.$store.dispatch("postProRetoucher/orderBroken", {role:'pro-retoucher', auto_order_check: value_auto_order_check}) : await this.$store.dispatch("postProRetoucher/orderBroken", {role:'pro-retoucher', auto_order_check: value_auto_order_check});
              data = await this.$store.getters['postProRetoucher/orderBroken'];
              break;
            case 'done-admin-for-customer':
              this.role === 'test-retoucher' ? await this.$store.dispatch("postProRetoucher/doneAdminForCustomer", {role:'pro-retoucher', auto_order_check: value_auto_order_check}) : await this.$store.dispatch("postProRetoucher/doneAdminForCustomer", {role:'pro-retoucher', auto_order_check: value_auto_order_check});
              data = await this.$store.getters['postProRetoucher/doneAdminForCustomer'];
              break;
            case 'wait-for-download-photo':
              this.role === 'test-retoucher' ? await this.$store.dispatch("postProRetoucher/waitForDownloadPhoto", {role:'pro-retoucher', auto_order_check: value_auto_order_check}) :
                  await this.$store.dispatch("postProRetoucher/waitForDownloadPhoto", {role:'pro-retoucher', auto_order_check: value_auto_order_check});
              data = await this.$store.getters['postProRetoucher/waitForDownloadPhoto'];
              break;
            case 'rejected-admin':
              this.closeDialog();
              let formData = new FormData();
              formData.append('auto_order_check', value_auto_order_check);
              formData.append('problem_level', this.selectedReasons.label);
              formData.append('problem_comment', this.rejectionDetails);
              formData.append('retoucher', this.selectedRetoucher);
              this.role === 'test-retoucher' ?
                  await this.$store.dispatch("postProRetoucher/rejectedAdmin", {
                    role: 'pro-retoucher',
                    data: formData,
                  }) :
                  await this.$store.dispatch("postProRetoucher/rejectedAdmin", {role: 'pro-retoucher', data: formData});
              data = await this.$store.getters['postProRetoucher/rejectedAdmin'];
              break;
            default:
              data.status = 'error';
              data.message = 'Unknown action';
          }

          if (data.status === 'ok') {
            this.$emit('reload', true);
          } else {
            alert(data.message);
            this.$emit('reload', true);
          }
        } catch (e) {
          this.$emit('reload', true);
        }
      }
    },
    validateReasoneReject(status) {
      if (status !== 'rejected-admin')
        return true;

      let validSelectedReason = this.isReasonSelectedValid;
      let validDetailReason = this.isFormValid;

      if (!validSelectedReason) {
        let checkedFunc = document.querySelectorAll('#checkedSelectedReason');
        checkedFunc.forEach(element => {
          element.classList.add('tm-val-error');
        });
        alert(this.local_page_keys.alert_check_the_function);
      }
      if (!validDetailReason) {
        let checkedFunc = document.querySelector('#detailReason');
        checkedFunc.classList.add('tm-val-error');
        alert(this.local_page_keys.alert_problem_required);
      }

      return validDetailReason && validSelectedReason;
    },
    changeRetoucher(selectObj) {
      if(selectObj == this.local_page_keys.select_another_retoucher) {
        this.selectedRetoucher = this.getObjectByOptionValue(this.retouchersList,'name', selectObj)
      } else if(selectObj == this.local_page_keys.select_same_retoucher){
        this.selectedRetoucher = this.whichRetoucherObj.email;
      } else if(selectObj){
        this.selectedRetoucher = selectObj;
      } else {
        this.selectedRetoucher = false;
      }
    },
    getObjectByOptionValue(array, optionName, optionValue) {
      return array.find(obj => obj[optionName] === optionValue);
    },
    /**
     * close re=done-admin window
     */
    closeDialog() {
      this.showDialog10 = false;
      //this.fixedPhoto.fields = null;
      //this.fixedPhoto.image = null;
      this.classDisplay = '';
    },
    /**
     * send request order 're-done-admin' to OrderController (method updateOrder)
     *
     * */
    async giveItToWork(){
      if (!this.validateDeletedFunction()){
        return;
      }

      let msg = this.local_page_keys.alert_you_confirm_the_sending_of_the_photo_for_redesign;
      if(this.prev_status_order == 'hold-admin-new') msg = this.local_page_keys.alert_you_confirm_sending_of_a_message_order_accepted;
      let formData = new FormData();

      formData.append('give_it_to_work', true);
      formData.append('auto_order_check',  new Number(this.auto_order_check).toString());
      if (confirm(msg)) {
        this.$emit('isLoading', true);

        if (this.selectedRetoucher) {
          await this.$emit('writeRejectedOrder', true);
        }
        let data;
        try {
          if (this.role === 'test-retoucher') {
            await this.$store.dispatch("postProRetoucher/reDoneAdmin", {data: formData, role: 'pro-retoucher'});
          } else {
            await this.$store.dispatch("postProRetoucher/reDoneAdmin", formData);
          }
          data = await this.$store.getters['postProRetoucher/reDoneAdmin'];
          if (data.status === 'ok') {
            this.$emit('reload', true);
          } else {
            alert(data.message);
            this.$emit('reload', true);
          }
        } catch (e) {
          this.$emit('reload', true);
        }
      }
    },
    removeClass() {
      let select = document.querySelector('#select_to_valid');
      select.classList.remove('tm-val-error');
    },
    getlevelsForselect() {
      let select = [];
      select.push(this.local_page_keys.option_bad)
      select.push(this.local_page_keys.option_too_bad)
      return select;
    },
    removeCheckedClass() {
      let checkedFunc = document.querySelector('#checkedFunctions');
      checkedFunc.classList.remove('tm-val-error');
      let textArea = document.querySelector('#validatedTextArea');
      textArea.classList.remove('tm-val-error');
    },
    async fetchRetouchersList() {
      let users;
      if (this.role === 'test-retoucher') {
        await this.$store.dispatch("users/retouchersList", 'test-retoucher');
      } else if (this.junior_order) {
        await this.$store.dispatch("users/retouchersList", 'junior-retoucher');
      } else {
        await this.$store.dispatch("users/retouchersList", "junior-and-retoucher");
      }
      let retouchersRejectedToAnotherList = await this.whichRetouchersRejectedToAnotherList();

      users = await this.$store.getters["users/retouchersList"];
      let retouchersList = []
      let usersList = Object.values(users);
      await this.$store.dispatch("order/whichRetoucher", this.order_id);

      let whichRetoucher = await this.$store.getters["order/whichRetoucher"];
      let whichRetoucherObj = usersList.find(item => Number(item.id) === Number(whichRetoucher.user_id));

      if(typeof whichRetoucherObj == 'object' && Object.keys(whichRetoucherObj).length > 0 && 'id' in whichRetoucherObj){
        this.$emit('whichRetoucher', whichRetoucher);
        this.whichRetoucherObj = whichRetoucherObj;
        this.selectedRetoucherObj = {
          "text": this.local_page_keys.select_same_retoucher,
          "value": this.local_page_keys.select_same_retoucher,
          "name": this.local_page_keys.select_same_retoucher,
          "class": "green",
        };
        retouchersList.push({
          "text": this.local_page_keys.select_same_retoucher,
          "value": this.whichRetoucherObj.email,
          "name":  this.local_page_keys.select_same_retoucher,
          "class": "",
        });
        this.selectedRetoucher = this.whichRetoucherObj.email;
        this.rejectedToAnotherRetoucher = this.whichRetoucherObj.email;
      }

      if(this.prev_status_order != 'hold-admin-new') {

        if (retouchersRejectedToAnotherList.length > 0 && usersList.length > 0) {
          usersList = usersList.filter((obj) => !retouchersRejectedToAnotherList.includes(obj.email));
        }
        retouchersList.push({
          "text": this.local_page_keys.select_another_retoucher,
          "value": this.local_page_keys.select_another_retoucher,
          "name": this.local_page_keys.select_another_retoucher,
          "status": 'rejected-to-another-retoucher',
          "class": "",
        });
      }

      if(retouchersList && retouchersList.length === 1){
        this.selectedRetoucher = this.local_page_keys.select_another_retoucher;
        this.selectedRetoucherObj = {
          "text": this.local_page_keys.select_another_retoucher,
          "value": this.local_page_keys.select_another_retoucher,
          "name": this.local_page_keys.select_another_retoucher,
          "status": 'rejected-to-another-retoucher',
          "class": "",
        };
      }

      if(Number(this.education) == 1){
        this.whichRetoucherObj = whichRetoucherObj;
        this.selectedRetoucherObj = {
          "text": this.local_page_keys.select_same_retoucher,
          "value": this.local_page_keys.select_same_retoucher,
          "name": this.local_page_keys.select_same_retoucher,
          "class": "green",
        };
        retouchersList = [{
          "text": this.local_page_keys.select_same_retoucher,
          "value": this.whichRetoucherObj.email,
          "name":  this.local_page_keys.select_same_retoucher,
          "class": "",
        }];
        this.selectedRetoucher = this.whichRetoucherObj.email;
        this.rejectedToAnotherRetoucher = this.whichRetoucherObj.email;
      }
      this.$emit('setRejectedToAnotherRetoucher', this.rejectedToAnotherRetoucher);
      this.retouchersList = retouchersList;
    },
    getRetouchersListOptionTextFromEmail(email){
      if(email){
        let retouchersList = this.retouchersList;
        let user = retouchersList.find((obj) => obj.value == email);
        if(typeof user == 'object' && 'text' in user && user.text != '') return user.text;
      }
      return email;
    },
    unselectRtoucher(){
      this.selectedRetoucher = false;
      this.selectedRetoucherObj = {};
    },
    async whichRetouchersRejectedToAnotherList(){
        await this.$store.dispatch("order/whichRetouchersRejectedToAnotherList", this.order_id);
        return await this.$store.getters["order/whichRetouchersRejectedToAnotherList"];
    },

    initializeChecked(newFaces = false) {
      let faces = newFaces ? newFaces : this.faces;
      this.checked = [];
      for (const face of Object.keys(faces)) {
        if (Object.keys(faces[face]).length === 1) {
          for ( const value of Object.keys(faces[face])) {
             this.checked.push(`${face}:${faces[face][value].RU}`);
          }
        }
      }
    },
    updateSelection() {
      if (this.isLastReasonSelected) {
        this.rejectionDetails = '';
      }
    },
    async showDialog(showDialog, validateRating) {
      if (!this.validateDeletedFunction()){
        return;
      }
      if (validateRating && showDialog === 'modeEdit') {
        await this.$emit('checkValidateRating');
        await this.$emit('setModeEdit', this.isValidateRate);
      } else this[showDialog] = true;
    },
    validateDeletedFunction() {
      if (this.permission === 'read')
          return true;

      let itemCount = 0;
      let deletedItemCount = 0;

      if (Array.isArray(this.faces)) {
        for (const item in this.faces) {
          if (item.hasOwnProperty('order_super_function') || item.hasOwnProperty('order_silver_super_function') || item.hasOwnProperty('order_subscription_super_function')) {
            continue;
          }

          for (const key in item) {
            const currentItem = item[key];
            if (currentItem.hasOwnProperty('deleted') && currentItem.deleted === true) {
              deletedItemCount++;
            }
            itemCount++;
          }
        }
      }
      if (deletedItemCount === itemCount) {
        alert(this.local_page_keys.alert_message_error_validate_deleted_function);
        return false;
      }
      return true;
    }
  },
  watch: {
    faces: {
      handler(newFaces) {
        this.initializeChecked(newFaces);
      },
    },
    selectedRetoucher: function (newVal, oldVal) { // watch it
      let selectedRetoucherHeader = '';
      if (newVal && typeof newVal == 'string') {
        selectedRetoucherHeader = this.getRetouchersListOptionTextFromEmail(newVal)
      } else if (typeof newVal === 'object' && newVal.hasOwnProperty('status')) {
        selectedRetoucherHeader = newVal.name;
      }

      this.$emit('setSelectedRetoucherHeader', newVal);
      this.$emit('setSelectedRetoucher', selectedRetoucherHeader);
    },
  },
  computed: {
    order_is_broken() {
      return this.main_photo_before === null && this.main_photo_after === null || this.faces === null;
    },
    isLastReasonSelected() {
      return this.selectedReasons === this.rejectReasons[this.rejectReasons.length - 1];
    },

    isReasonSelectedValid() {
      return this.selectedReasons.label && this.selectedReasons.label.length > 0;
    },
    isFormValid() {
      return this.isReasonSelectedValid && (!this.isLastReasonSelected || this.rejectionDetails.trim() !== '');
    },
    //1482 	Выберите хотя бы одну функцию
    //1833 	Поле обязательно для заполнения
  },
  created() {
    if (this.main_photo_after === null) {
      this.beforeModalVisible = true;
    } else {
      this.afterModalVisible = true;
    }
    this.fetchRetouchersList();
    this.initializeChecked();
  },
}
</script>

<style scoped>
/*Layout*/
@import '../../../../assets/css/uikit/grid.css';
/*Utilities*/
@import '../../../../assets/css/uikit/background.css';
@import '../../../../assets/css/uikit/label.css';
@import '../../../../assets/css/uikit/width.css';
@import '../../../../assets/css/uikit/height.css';
@import '../../../../assets/css/uikit/flex.css';
@import '../../../../assets/css/uikit/margin.css';
@import '../../../../assets/css/uikit/padding.css';
@import '../../../../assets/css/uikit/position.css';
@import '../../../../assets/css/uikit/utility.css';
@import '../../../../assets/css/uikit/transition.css';
@import '../../../../assets/css/uikit/text.css';
@import '../../../../assets/css/uikit/overlay.css';
@import '../../../../assets/css/uikit/animation.css';
@import '../../../../assets/css/custom.css';

.tm-file-name {
  word-break: break-all;
  line-height: 1;
}

.prev-img {
  width: 60px;
  height: 60px;
  background-color: #ccc
}

#files-area {
  border-radius: 6px;
  border: 3px dashed #e8e8e8;
  background-color: #f5f5f5;
  min-height: 100px;
}

.file-block {
  overflow: hidden;
  border-radius: 6px;
  background-color: rgba(144, 163, 203, 0.2);
  margin: 5px 0;
}

.tm-file-delete {
  cursor: pointer;
  padding: 10px;
}

/*.tm-button-add {*/
/*  padding: 0px 9px;*/
/*  border-radius: 50px;*/
/*}*/

.main-photo-dialog {
  height: 100%;
}

.left-part-main-photo {
  width: 100%;
}

.buttons {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.comments-button {
  border: #297a96 2px solid;
  border-radius: 5px;
  width: 75%;
  height: 90%;
  background: none;
  color: #3e3d3d;
  margin: 2px;
}

.scrollable-dialog {
  max-height: 80% !important;
  overflow-y: auto;
}

.checkFunctions {
  display: contents;
}

.image-compare-handle {
  color: #f10404;
  background-color: currentColor;
  cursor: ew-resize;
  transform: translateX(-50%) translateZ(0);
  width: 2px;
  z-index: 2;
  will-change: left;

}

/*.tm-block-img {*/
/*  background-color: #f0f0f0;*/
/*  width: 550px;*/
/*  height: 550px;*/
/*  display: -webkit-box;*/
/*  display: -ms-flexbox;*/
/*  display: flex;*/
/*  -webkit-box-align: center;*/
/*  -ms-flex-align: center;*/
/*  align-items: center;*/
/*  -webkit-box-pack: center;*/
/*  -ms-flex-pack: center;*/
/*  justify-content: center;*/
/*}*/

/*.tm-order-check .tm-block-img img {*/
/*  height: 100%;*/
/*  object-fit: contain;*/
/*}*/

/*.main-photo-image {*/
/*  min-width: 550px;*/
/*}*/

.display {
  display: none;
}

.cancel-order {
  margin: auto;
}

</style>